import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import React, { useState } from 'react';
import './App.css';
import PrivateRoute from './components/common/PrivateRoute';
import PublicRoute from './components/common/PublicRoute';
import Login from './pages/Login/Login';
import Registration from './pages/Registration/Registration';
import Activate from './pages/Password/Activate';
import ActivateUser from './pages/Password/ActivateUser';
import Verify from './pages/Verify/Verify'
import ForgotPassword from './pages/Password/ForgotPassword';
import ResendVerificationEmail from './pages/Verify/ResendVerificationEmail'
import ResetPassword from './pages/Password/ResetPassword';
import Home from './pages/Home/Home';
import Dashboard from './pages/Dashboard/Dashboard';
import UserManagement from './pages/UserManagement/UserManagement';
import AccountManagement from './pages/AccountManagement/AccountManagement';
import LicenseManagement from './pages/LicenseManagement/LicenseManagement';
import Cms from './pages/Cms/Cms';
import CmsSupport from './pages/Cms/CmsSupport';
import Roles from './pages/Roles/Roles';
import AlertPlus from './pages/AlertPlus/AlertPlus';
import AlertLogs from './pages/AlertPlus/AlertLogs/AlertLogs';
import AlertUsers from './pages/AlertPlus/AlertUsers/AlertUsers';
import AlertTemplates from './pages/AlertPlus/AlertTemplates/AlertTemplates';
import AlertRequestsPage from "./pages/AlertPlus/AlertRequestsPage/AlertRequestsPage";
import ClassroomDetailsPage from "./pages/AlertPlus/ClassroomDetails/ClassroomDetailsPage";
import RaptorLogs from './pages/Raptor/RaptorLogs/RaptorLogs';
import Orchestrate from './pages/Orchestrate/Orchestrate';
import HardwareWarranty from './pages/HardwareWarranty/HardwareWarranty';
import Settings from './pages/Settings/Settings';
import SSOCMS from './pages/SSO/SSO-CMS-OLD/SSO';
import SSOCMSNEW from './pages/SSO/SSO-CMS/SSO';
import SSO from './pages/SSO/SSO'
import AlertsPlusTemplate from './pages/AlertsPlusTemplate/AlertsPlusTemplate'
import Forbidden from './pages/Error/forbidden'
import ChangePassword from "./pages/Password/ChangePassword";
import Sandbox from './pages/Sandbox/sandbox';
import RaptorConfiguration from './pages/Raptor/Configuration/Configuration';
import RaptorSiteMapping from './pages/Raptor/SiteMapping/SiteMapping';
import MessageStatus from './pages/MessageManager/MessageStatus/MessageStatus';
import CreateMessage from './pages/MessageManager/CreateMessage/CreateMessage';
import GroupManagement from './pages/MessageManager/GroupManagement/GroupManagement';
import MessageLogs from './pages/MessageManager/MessageLogs/MessageLogs';
import MessageUsers from './pages/MessageManager/MessageUsers/MessageUsers';
import TrialProvisioning from './pages/TrialProvisioning/TrialProvisioning';
import Support from './pages/Support/Support';
import SupportActivate from './pages/SupportTools/SupportActivate';
import RxPlayback from './pages/MessageManager/RxPlayback';
import SignageDashboardAdmin from './pages/SignagePlus/SignageDashboard/SignageDashboardAdmin/SignageDashboardAdmin';
import SignageDashboardOwner from './pages/SignagePlus/SignageDashboard/SignageDashboardOwner/SignageDashboardOwner';
import SigangeDashboardTeacher from './pages/SignagePlus/SignageDashboard/SigangeDashboardTeacher/SigangeDashboardTeacher';
//import SignageDashboard from './pages/SignagePlus/SignageDashboard/SignageDashboard';
import CreateSignage from './pages/SignagePlus/CreateSignage/CreateSignage';
import SignageCreatePlaylist from './pages/SignagePlus/SignageCreatePlaylist/SignageCreatePlaylist';
import SignageCanvaOauth from './pages/SignagePlus/SignageCanvaOauth/SignageCanvaOauth';
import SignageDrafts from './pages/SignagePlus/SignageDrafts/SignageDrafts';
import SignageGroupManagement from './pages/SignagePlus/SignageGroupManagement/SignageGroupManagement';
import SignageLogs from './pages/SignagePlus/SignageLogs/SignageLogs';
import SignageMediaLibrary from './pages/SignagePlus/SignageMediaLibrary/SignageMediaLibrary';
import SignageUsers from './pages/SignagePlus/SignageUsers/SignageUsers';
import SinglewireConfiguration from './pages/Singlewire/Configuration/Configuration';
import SinglewireSiteMapping from './pages/Singlewire/SiteMapping/SiteMapping';
import SinglewireLogs from './pages/Singlewire/SinglewireLogs/SinglewireLogs';

function App(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const navbarProps = {
    isSidebarOpen, setIsSidebarOpen
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/sandbox" element={<Sandbox />} />
        <Route path="/verify" element={<Verify />} />
        <Route path="/login" element={<PublicRoute><Login /> </PublicRoute>} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/activate" element={<Activate />} />
        <Route path="/activate-user" element={<ActivateUser/>}/>
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/resend-verification-email" element={<ResendVerificationEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/sso/cms" element={<SSOCMS product="CMS"/>}/>
        <Route path="/sso/cms-new" element={<SSOCMSNEW product="CMS"/>}/>
        <Route path="/sso/" element={<SSO/>}/>
        <Route path="/signage-plus/canva-oauth" element={<SignageCanvaOauth/>}/>
        <Route path="/aplus-template" element={<AlertsPlusTemplate />}/>
        <Route element={<PrivateRoute><Home {...navbarProps} /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="/account-management" element={<AccountManagement/>}/>
          <Route path="/user-management" element={<UserManagement isSidebarOpen={isSidebarOpen}/>} />
          <Route path="/account-management" element={<AccountManagement/>} />
          <Route path="/license-management" element={<LicenseManagement />} />
          <Route path="/cms" element={<Cms />} />
          <Route path="/cms-support" element={<CmsSupport />} />
          <Route path="/roles" element={<Roles />} />
          <Route path="/alert-plus/manage" element={<AlertPlus />} />
          <Route path="/alert-plus/logs" element={<AlertLogs />} />
          <Route path="/alert-plus/Users" element={<AlertUsers />} />
          <Route path="/alert-plus/templates" element={<AlertTemplates />} />
          <Route path="/alert-requests" element={<AlertRequestsPage />} />
          <Route path="/classroom-details" element={<ClassroomDetailsPage />} />
          <Route path="/raptor/configuration" element={<RaptorConfiguration />} />
          <Route path="/raptor/site-mapping" element={<RaptorSiteMapping />} />
          <Route path="/raptor/logs" element={<RaptorLogs />} />
          <Route path="/orchestrate" element={<Orchestrate />} />
          <Route path="/hardware-warranty" element={<HardwareWarranty />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/message-manager/users" element={<MessageUsers />} />
          <Route path="/message-manager/group-management" element={<GroupManagement />} />
          <Route path="/message-manager/logs" element={<MessageLogs />} />
          <Route path="/message-manager/status" element={<MessageStatus />} />
          <Route path="/message-manager/create-message" element={<CreateMessage />} />
          <Route path="/signage-plus/dashboard-admin" element={<SignageDashboardAdmin />} /> 
          <Route path="/signage-plus/dashboard-owner" element={<SignageDashboardOwner />} />    
          <Route path="/signage-plus/dashboard-teacher" element={<SigangeDashboardTeacher />} />
          <Route path="/signage-plus/users" element={<SignageUsers />} />
          <Route path="/signage-plus/group-management" element={<SignageGroupManagement />} />
          <Route path="/signage-plus/logs" element={<SignageLogs />} />
          <Route path="/signage-plus/create-signage" element={<CreateSignage />} />
          <Route path="/signage-plus/drafts" element={<SignageDrafts />} />
          <Route path="/signage-plus/create-playlist" element={<SignageCreatePlaylist />} />
          <Route path="/signage-plus/media-library" element={<SignageMediaLibrary />} />
          <Route path="/singlewire/configuration" element={<SinglewireConfiguration />} />
          <Route path="/singlewire/site-mapping" element={<SinglewireSiteMapping />} />
          <Route path="/singlewire/logs" element={<SinglewireLogs />} />
          {/* <Route path="/alert-plus/api-key" element={<ApiKey />} />
          <Route path="/alert-plus/site-mapping" element={<SiteMapping />} /> */}
          <Route path="/trial-provisioning" element={<TrialProvisioning />} />
          <Route path="/support" element={<Support />} />
          <Route path="/support-activate" element={<SupportActivate />} />
        </Route>
        <Route path="/forbidden" element={<Forbidden/>}/>
        <Route path="/rx-playback" element={<RxPlayback/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
